import React from "react"
import gatsbyImg from "../../../images/gatsby.svg";

const GatsbyImage = () => (
  <img src={gatsbyImg} alt="Made with Gatsby" width="163" height="31"/>

)
export default GatsbyImage
